/**
 * Route guards.
 *
 * These are a UX convenience, not a security boundary -- the API enforces
 * permissions on every request regardless of what the client renders. Their job
 * is to send a visitor somewhere useful instead of showing them a page that will
 * only produce a 401 or 403.
 */

import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { EmptyState } from '@/components/ui'
import { useSession } from '@/hooks/useAuth'

/** Requires a signed-in member; remembers where they were headed. */
export const RequireAuth = () => {
  const { isAuthenticated } = useSession()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname + location.search }} />
  }
  return <Outlet />
}

/** Requires library staff. */
export const RequireStaff = () => {
  const { t } = useTranslation()
  const { isAuthenticated, isStaff } = useSession()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname + location.search }} />
  }
  if (!isStaff) {
    return <EmptyState title={t('errors.permission_denied')} />
  }
  return <Outlet />
}
